import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'invo_infoid': {
    title: '制票通知单号',
    type: 'input',
  },
  'w_invo_infoid': {
    title: '外部制票通知单号',
    type: 'input',
    equation: all,
    width: 180
  },
  'inf_type': {
    describe: true,
    title: '制票通知单类型',
    type: 'select',
    equation: city,
    dictionary: 'A0022',
    width: 150
  },
  'inv_status': {
    describe: true,
    title: '制票通知单状态',
    type: 'select',
    equation: city,
    dictionary: 'A0033',
    width: 130
  },
  'kp_message': {
    title: '推送开票系统'
  },
  'customer': {
    title: '开票客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '开票客户编号'
    },
    unSearchRole: 'WLY001'
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 200,
    unSearchRole: 'WLY001'
  },
  'zzfld000001': {
    describe: true,
    title: '营销区域',
    type: 'select',
    equation: all,
    dictionary: 'sale',
    unSearchRole: 'WLY001'
  },
  'zzfld00003e': {
    describe: true,
    title: '基地',
    dictionary: 'base',
    unSearchRole: 'WLY001'
  },
  'inv_amount': {
    title: '发票金额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'inv_type': {
    describe: true,
    title: '发票类型',
    dictionary: 'A0032'
  },
  'chan_date': {
    title: '换票日期',
  },
  'mak_date': {
    title: '开票日期',
    type: 'date',
    equation: all,
    defaultVal: new Date()
  },
  'mark_print': {
    title: '是否已打印',
  },
  'zzfld00002d_dscr': {
    title: '创建人',
  },
  'remark': {
    title: '制票通知单表头备注',
  },
  'zzfld00002j': {
    describe: true,
    title: '运达方类型',
    dictionary: 'A0009'
  },
  'zzfld00008t': {
    title: '运达方编码',
    dialog: {
      component: 'ClientSelect',
      title: '运达方编码'
    }
  },
  'zzfld00008t_dscr': {
    title: '运达方名称',
    width: 200
  },
  'recinv_pers': {
    title: '收票联系人',
  },
  'recinv_tel': {
    title: '联系电话',
  },
  'inv_addr': {
    title: '收票地址',
    width: 200
  },
  'datum': {
    title: '创建日期',
  }
}



// WEBPACK FOOTER //
// ./src/views/invoice-manage/config/componentInvoiceDetailQuery.js